import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { router } from "./router";
import { Providers } from "./app/providers";
import "./styles/globals.css";

const container = document.getElementById("root");
if (!container) throw new Error("Root container #root not found in index.html");

createRoot(container).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
